import {request} from '@/axios'

/**
 * @description 創建訂單
 * @param {Object} data
 */
export function createOrder(data) {
  return request({
    url: '/order/create',
    method: 'post',
    data
  })
}

/**
 * @description 換取支付Nonce
 * @param {Object} params
 */
export function getPaymentNonce(params) {
  return request({
    url: '/payment/order/detail',
    method: 'get',
    params
  })
}

/**
 * @description b端接單
 * @param {Object} data
 */
export function acceptOrder(data) {
  return request({
    url: '/order/accept/master',
    method: 'post',
    data
  })
}

/**
 * @description c端取消訂單
 * @param {Object} data
 */
export function cancelOrder(data) {
  return request({
    url: '/order/cancel/normal',
    method: 'post',
    data
  })
}

/**
 * @description c端確認完成訂單
 * @param {Object} data
 */
export function completeOrder(data) {
  return request({
    url: '/order/complete',
    method: 'post',
    data
  })
}
/**
 * @description c端確認完成訂單
 * @param {Object} data
 */
export function isFirstOrder(data) {
  return request({
    url: '/account/check/firstOrder',
    method: 'post',
    data
  })
}
/**
 * @description c端申訴
 * @param {Object} data
 */
export function controversyOrder(data) {
  return request({
    url: '/order/controversy',
    method: 'post',
    data
  })
}

/**
 * @description c端評價
 * @param {Object} data
 */
export function reviewOrder(data) {
  return request({
    url: '/comment/write',
    method: 'post',
    data
  })
}

/**
 * @description b端拒絕退款
 * @param {Object} data
 */
export function rejectControversy(data) {
  return request({
    url: '/order/reject/return/player',
    method: 'post',
    data
  })
}

/**
 * @description b端同意退款
 * @param {Object} data
 */
export function confrimControversy(data) {
  return request({
    url: '/order/accept/return/master',
    method: 'post',
    data
  })
}

/**
 * @description 獲取訂單詳情
 * @param {Object} data
 */
export function orderDetail(params) {
  return request({
    url: '/order/detail',
    method: 'get',
    params
  })
}


/**
 * @description 修改服務信息
 * @param {Object} data
 */
export function saveServe(data) {
  return request({
    url: '/player/skill/certification/save',
    method: 'post',
    data
  })
}

/**
 * @description 獲取服務信息
 * @param {Object} data
 */
export function getServeInfo(params) {
  return request({
    url: '/player/skill/detail/info',
    method: 'get',
    params
  })
}

/**
 * @description 獲取遊戲信息
 * @param {Object} data
 */
export function getGameInfo(params) {
  return request({
    url: '/player/skill/certification/gameinfo',
    method: 'get',
    params
  })
}

/**
 * @description 獲取評價標籤
 */
export function getCommentTags() {
  return request({
    url: '/comment/tag/list',
    method: 'get'
  })
}

/**
 * @description B端提交對C端的評價
 */
export function createCommentToNormal(data) {
  return request({
    url: '/comment/player/write',
    method: 'post',
    data
  })
}

/**
 * @description B端確認訂單
 */
export function bCompleteOrder(data) {
  return request({
    url: '/order/playerConfirm',
    method: 'post',
    data
  })
}

/**
 * @description B端確認訂單
 */
export function bindOrder(data) {
  return request({
    url: '/payment/reportPayPalResult',
    method: 'post',
    data
  })
}

/**
 * @description 未支付取消订单
 */
export function cancelPay(data) {
  return request({
    url: '/order/unpaid/cancel/normal',
    method: 'post',
    data
  })
}
/**
 * @description 再次订单
 */
export function rePay(data) {
  return request({
    url: '/order/repay',
    method: 'post',
    data
  })
}

/**
 * @description 支付成功报告
 *  
 */
export function reportStripeResult(data) {
  return request({
    url: '/payment/reportStripeResult',
    method: 'post',
    data
  })
}
